<template>
  <div v-loading="isSaveLoading">
    <div class="wt-user-breadcrumb">
      <div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>个人中心</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="wt-user-breadcrumb-page-title">个人中心</div>
      </div>
    </div>
    <div class="wt-basic-title">基本信息</div>
    <el-form class="account-base" ref="form" :model="detailResult" :rules="rules" size="small" label-width="120px"
             style="max-width: 400px;margin: 0 32px;">
      <el-form-item label="头像：">
        <div style="display: flex;align-items: center;">
          <el-avatar v-if="!detailResult.photo" icon="el-icon-user-solid"></el-avatar>
          <el-image v-if="detailResult.photo"
                style="width: 50px; height: 50px; border-radius: 50%;"
                :src="imgUrl + detailResult.photo"
                fit="cover"></el-image>
          <el-upload
            :show-file-list="false"
            style="margin-left: 20px;"
            :action="uploadUrl"
            :on-success="onSuccessUpload"
            >
            <el-button size="mini" type="primary">修改</el-button>
          </el-upload>
        </div>

      </el-form-item>
      <el-form-item label="昵称：">
        <el-input v-model="detailResult.username" placeholder="请输入昵称" disabled></el-input>
      </el-form-item>
      <el-form-item label="姓名：" prop="realname">
        <el-input v-model="detailResult.realname" placeholder="请输入姓名" disabled></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="mobile">
        <el-input v-model="detailResult.mobile" placeholder="请输入手机号" disabled></el-input>
      </el-form-item>
      <el-form-item label="当前密码：" prop="oldPassword" v-if="isModifyPassword">
        <el-input v-model="detailResult.oldPassword" type="password" placeholder="请输入当前密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newPassword" v-if="isModifyPassword">
        <el-input v-model="detailResult.newPassword" type="password" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="confirmPassword" v-if="isModifyPassword">
        <el-input v-model="detailResult.confirmPassword" type="password" placeholder="请输入确认密码"></el-input>
      </el-form-item>
      <el-form-item label="邮箱：" prop="email">
        <el-input v-model="detailResult.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="returnRoute">返回</el-button>
        <el-button type="primary" @click="onSave">确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="提示" custom-class="app-dialog" :destroy-on-close="true" :modal="false"
               :visible.sync="dialogVisible">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="dialog2Visible = true">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import request from '@/utils/request'
import { mapState } from 'vuex'

export default {
  data() {
    const that = this
    const ValidatorPassword = (rule, value, callback) => {
      if (that.detailResult.newPassword !== that.detailResult.confirmPassword) {
        return callback(new Error('两次输入的密码必须相同'))
      }
      return callback()
    }
    const ValidatorOldPassword = (rule, value, callback) => {
      if (that.detailResult.oldPassword === that.detailResult.newPassword) {
        return callback(new Error('输入的新旧密码相同,请重新输入'))
      }
      return callback()
    }
    const ValidatorEmptyPassword = (rule, value, callback) => {
      if (that.detailResult.oldPassword !== '' && that.detailResult.newPassword === '') {
        return callback(new Error('请输入新密码'))
      }
      return callback()
    }
    const ValidatorEmptyOldPassword = (rule, value, callback) => {
      if (that.detailResult.oldPassword === '' && that.detailResult.newPassword !== '') {
        return callback(new Error('请输入当前密码'))
      }
      return callback()
    }
    return {
      dialogVisible: false,
      dialog2Visible: false,
      isSaveLoading: false,
      isModifyPassword: true,
      uploadUrl: window.wtConst.BASE_API + '/modules/authFile/uploadFile',
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: {},
      rules: {
        username: [{ required: false, message: '请输入用户名', trigger: 'blur' }, { validator: this.$wtValidator.ValidatorNotBlank, message: '输入内容不能为空', trigger: 'blur' }],
        realname: [{ required: false, message: '请输入姓名', trigger: 'blur' }, { validator: this.$wtValidator.ValidatorNotBlank, message: '输入内容不能为空', trigger: 'blur' }],
        oldPassword: [
          { required: false, message: '请输入当前密码', trigger: 'blur' },
          { min: 5, max: 20, message: '密码长度需要5-20位', trigger: 'blur' },
          { validator: ValidatorEmptyOldPassword, trigger: 'blur' }],
        newPassword: [{ required: false, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 16, message: '密码长度需要5-16位', trigger: 'blur' },
          { validator: ValidatorOldPassword, trigger: 'blur' },
          { validator: ValidatorEmptyPassword, trigger: 'blur' }],
        confirmPassword: [{ required: false, message: '请输入确认密码', trigger: 'blur' },
          { validator: ValidatorPassword, trigger: 'blur' }],
        mobile: [{ required: false, message: '请输入手机号码', trigger: 'change' }],
        telephone: [{ required: true, message: '请输入座机号码', trigger: 'change' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'change' }],
        email: [{ required: false, message: '请输入电子邮箱', trigger: 'change' }],
        photo: [{ required: true, message: '请输入用户头像', trigger: 'change' }],
        duty: [{ required: true, message: '请输入职务/岗位', trigger: 'change' }],
        organizationId: [{ required: true, message: '请输入机构ID', trigger: 'change' }],
        totalPoint: [{ required: true, message: '请输入总点数', trigger: 'change' }],
        point: [{ required: true, message: '请输入剩余点数', trigger: 'change' }],
        expireTime: [{ required: true, message: '请输入账号过期时间', trigger: 'change' }],
        approvalState: [{ required: true, message: '请输入审批状态', trigger: 'change' }],
        orderNum: [{ required: true, message: '请输入排序', trigger: 'change' }],
        isLogout: [{ required: true, message: '请输入是否登出', trigger: 'change' }],
        isPublish: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  activated() {
    // this.$store.dispatch('queryAccountDetailData', this.userId)
  },
  methods: {
    onSave() {
      const that = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$confirm('是否保存?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            that.requestUpdateAccountDetail()
          }).catch(() => {
            that.isSaveLoading = false
          })
        } else {
          return false
        }
      })
    },
    returnRoute() {
      this.$router.back()
    },
    onSuccessUpload(file) {
      console.log(file, file.code)
      if (file.code === '0') {
        this.detailResult.photo = file.data[0].fileUrl
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestUpdateAccountDetail() {
      const that = this
      that.isSaveLoading = true
      request({
        url: '/modules/auth/accountUpdateSelf',
        method: 'post',
        data: {
          confirmPassword: this.detailResult.confirmPassword,
          email: this.detailResult.email,
          newPassword: this.detailResult.newPassword,
          oldPassword: this.detailResult.oldPassword,
          photo: this.detailResult.photo
        }
      }).then(response => {
        console.log(this.detailResult)
        if (this.detailResult.newPassword && this.detailResult.newPassword.length > 0) {
          that.$message({ message: '密码重置成功，请重新登录', type: 'success' })
          setTimeout(() => {
            this.$store.dispatch('FedLogOut').then(() => {
              location.reload()// 为了重新实例化vue-router对象 避免bug
            })
          })
        } else {
          that.$message({ message: '保存成功', type: 'success' })
        }
        that.isSaveLoading = false
        // that.$store.dispatch('queryAccountDetailData', that.userId)
      }).catch(() => {
        that.isSaveLoading = false
      })
    }
  },
  created() {
    this.$store.dispatch('queryAccountDetailData', this.userId)
  },
  computed: {
    ...mapState({
      userId: state => state.auth.userId,
      detailResult: state => state.auth.accountDetailData
    })
  }
}
</script>

<style lang="scss" scoped>
  .wt-basic-title{font-size: 22px;color: #333; margin: 24px 0px;margin-left: 50px;}
  .wt-user-breadcrumb {
    background-color: #FFFFFF;
    color: #666666;
    height: 100px;
    padding: 20px 80px 20px 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    margin: 0;
    .wt-user-breadcrumb-page-title {
      padding-top: 20px;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
    }
  }
</style>
<style lang="scss">
.account-base .el-input.is-disabled .el-input__inner{
  border: 0;
  background-color: transparent;
  color: #333333;
}
.wt-user-breadcrumb {
  .el-breadcrumb__item {
    font-size: 14px;
    .el-breadcrumb__inner {
      color: #999999;
    }
    & + .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: #666666;
      }
    }
  }
}
</style>
